import SelectorEngine from '../utils/dom/selector-engine';
import EventHandler from '../utils/dom/event-handler';

const initCounterDemo = () => {
	const counter = SelectorEngine.findOne('#counter-demo');
	const eventLog = SelectorEngine.findOne('#js-counter-demo-event-log');

	if (!counter || !eventLog) {
		return;
	}

	EventHandler.on(counter, 'counter-change', (event) => {
		const { oldValue, newValue } = event.detail;
		eventLog.textContent = 'Event: counter-change — oldValue: ' + oldValue + ', newValue: ' + newValue;
	});
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initCounterDemo);
} else {
	initCounterDemo();
}
